import $ from "jquery";
import { addressFormatter } from "../framework/addressFormatter";
import { countryState } from "./countryState";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import intlTelInput from 'intl-tel-input';

let itiPhone = {};

function init() {
    countryState.populateCountriesSelect("#AddSiteCountrySelect", "#NaStateSelection");
    setEvents();
}

function setEvents() {
    $(document).on("change", "#AddSiteCountrySelect", evtAddSiteCountrySelectChange);
    $(document).on("change", "#AddSiteStateSelect", evtAddSiteStateSelectChange);
    $(document).on("change", "#AddSiteRegionSelect", evtAddSiteRegionSelectChange);
    $(document).on("change", "#addSiteAreaSelect", evtAddSiteAreaSelectChange);
    $(document).on("change", "#Military", evtMilitaryChange);
    $(document).on("click", "#btnAddSiteSubmit", evtSiteSubmitClick);
    itiPhone = intlTelInput(document.querySelector("#addSitePhoneNumber"), { utilsScript: "/dist/utils.js", autoPlaceholder: "aggressive", initialCountry: $("#txtSelectedCountry").val() });
    $(document).on("change", "#addSitePhoneNumber", function () {
        $("#addSiteValidationPhoneSpan").addClass("hidden");
        if (!itiPhone.isValidNumber()) {
            $("#addSiteValidationPhoneSpan").removeClass("hidden");
        }
    });
    $(document).on("click", "#btnNewTraumaCenter", evtNewTraumaSiteClick);
    $(document).on("click", "#btnNewSite", evtNewSiteClick);
    $(document).on("click", "#MilitarySite", calculateRegionId);
}

function evtNewTraumaSiteClick() {
    console.log("evtNewTraumaSiteClick");
    document.getElementById("IsHostSite").value = "false";
    document.getElementById("header").innerHTML = "Add New Trauma Center";
}

function evtNewSiteClick() {
    console.log("evtNewSiteClick");
    document.getElementById("IsHostSite").value = "true";
    document.getElementById("header").innerHTML = "Add New Course Site";
}

function evtSiteSubmitClick() {
    const $form = $(this).closest("form");

    if (!$form.valid()) {
        return;
    }

    $("#addSiteValidationPhoneSpan").addClass("hidden");
    if ($("#addSitePhoneNumber").val() !== "" && !itiPhone.isValidNumber()) {
        $("#addSiteValidationPhoneSpan").removeClass("hidden");
        return;
    }

    $("#txtEditSitePhoneNumber").val(itiPhone.getNumber());

    forms.disableSubmitButton();
    $form.submit();
}

function evtAddSiteCountrySelectChange() {
    const selectedCountry = $(this).val();
    itiPhone.setCountry(selectedCountry);
    countryState.populateStatesSelect("#NaStateSelection", "#NonNaState", selectedCountry);
    addressFormatter.maskPhone($("#addSitePhoneNumber"), selectedCountry);
    addressFormatter.maskZip($("#addSitePostalCode"), selectedCountry);
    addressFormatter.showIfUsOrCa("#NaStateSelection, #NaPostalReq", selectedCountry);
    addressFormatter.showIfNotUsOrCa("#NonNaState", selectedCountry);

    if (addressFormatter.isUsOrCa(selectedCountry)) {
        $("#NonNaState input").val("");
    }

    calculateRegionId();
}

function evtAddSiteStateSelectChange() {
    calculateRegionId();
}

function evtAddSiteRegionSelectChange() {
    loadAreas();
}

function evtMilitaryChange() {
    calculateRegionId();
}

function evtAddSiteAreaSelectChange() { }

function calculateRegionId() {
    const militaryValue = $("#MilitarySite").is(":checked");
    const countryCodeValue = $("#AddSiteCountrySelect").val();
    let stateIdValue = $("#AddSiteStateSelect").val();
    if (countryCodeValue === "") {
        return;
    }
    if (stateIdValue === "") {
        stateIdValue = "0";
    }
    dataaccess
        .get({
            url:
                "/api/Region/GetRegionId/" +
                militaryValue +
                "/" +
                countryCodeValue +
                "/" +
                stateIdValue
        })
        .done(function (result) {
            $("#AddSitehdnRegionId").val(result);
            $("#AddSitetxtRegionId").val(result);
            loadAreas(result);
        })
        .fail(function () {
            $("#AddSitehdnRegionId").val(0);
            $("#AddSitetxtRegionId").val(0);
            loadAreas(0);
        });
}

function loadAreas() {
    const regionId = $("#AddSitehdnRegionId").val();
    const countryCodeValue = $("#AddSiteCountrySelect").val();
    let stateIdValue = $("#AddSiteStateSelect").val();
    if (stateIdValue === "") {
        stateIdValue = "0";
    }
    $("#AddSiteAreaSelect")
        .find("option")
        .not(":first")
        .remove()
        .end();
    dataaccess
        .get({
            url:
                "/api/area/GetAreasForRegionId/" +
                regionId +
                "/" +
                countryCodeValue +
                "/" +
                stateIdValue
        })
        .done(function (results) {
            for (let i = 0; i < results.length; i++) {
                if (results[i].selected === true) {
                    $("#AddSiteAreaSelect").append(
                        "<option value='" +
                        results[i].areaId +
                        "' selected>" +
                        results[i].areaName +
                        "</option>"
                    );
                } else {
                    $("#AddSiteAreaSelect").append(
                        "<option value='" +
                        results[i].areaId +
                        "'>" +
                        results[i].areaName +
                        "</option>"
                    );
                }
            }
        })
        .fail(function () {
            $("#AddSiteAreaSelect").append(
                "<option value='" + 0 + "'>" + "Error Getting Areas" + "</option>"
            );
        });
}
export const addSite = {
    init: init
};
